import {
  TableCellType,
  TableHeader,
} from "../../../components/custom-table/table";

export const draftCptTableHeader: TableHeader[] = [
  {
    label: "CPT Code",
    key: "cptCode",
    width: 20,
    order: 1,
    type: TableCellType.STRING,
  },
  {
    label: "CPT Description",
    key: "cptDescription",
    width: 80,
    order: 2,
    type: TableCellType.STRING,
  },
];
